__turbopack_context__.v({
  "dot": "PanelCornerDots-module__xttKTa__dot",
  "ellipsesRow": "PanelCornerDots-module__xttKTa__ellipsesRow",
});
